import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-complete-profile-success',
  templateUrl: './complete-profile-success.component.html',
  styleUrls: ['./complete-profile-success.component.scss'],
})
export class CompleteProfileSuccessComponent implements OnInit {

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }

}
